import {Button, Col, Container, Row} from "react-bootstrap";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {
    BASE_URL, ICONS_PUBLIC_URL_SERVER, IMG_SLIDER_STORES_URL_SERVER, PUBLIC_URL_SERVER, USERS_ADDRESS_GET, ANDROID_APP_DOWNLOAD_URL
} from "../../../../../apis";
import imgPlayS from "../../../../../images/base-image-product.jpg";
import axios from "axios";
// import swal from 'sweetalert';
import Swal from 'sweetalert2';
import {
    actionHandelRemoveAllItemInBasketCart,
    actionRefreshModalShoppingCard
} from "../../../../../redux/actions/modals/modalShoppingCard";
import {changeSelectedDefaultMarket} from "../../../../../redux/actions/markers/markets";
import {useHistory} from "react-router-dom";
import {handelOpenModalLoginAndRegister} from "../../../../../redux/actions/modals/modalLoginAndRegister";
import {
    actionModalChangeAddressChangeLoader,
    actionModalChangeAddressChangeShow
} from "../../../../../redux/actions/modals/modalChangeAddress";
import {actionGetAddressUser} from "../../../../../redux/actions/user/user";
import imgLoader from "./../../../../../images/icon-loader.png";// Import Swiper React components
import {Swiper, SwiperSlide} from 'swiper/react';
import useWindowDimensions from "../../../../../styles/lib/getWindowSize";
import {actionChangeDataShoppingCart} from "../../../../../redux/actions/shoppingCart";
import {FaAngleDown, FaAngleRight} from "react-icons/all";
import _ from "lodash";
import ic_bronze from "../../../../../images/icons/ic_bronze_36.png";
import ic_silver from "../../../../../images/icons/ic_silver_36.png";
import ic_gold from "../../../../../images/icons/ic_gold_36.png";
import ic_carrot from "../../../../../images/icons/ic_carrot_36.png";
import {FaInfoCircle} from "react-icons/all";
// import {handelOpenModalRankGuide} from "../../../../../redux/actions/modals/modalRankGuide";

import {useLocation} from "react-router-dom";
import {actionChangeHandelModalAddPrice, actionChangeInputsModalAddPrice} from "../../../../../redux/actions/modals/modalAddPrice";


const ListStores = () => {


    const {token, activeAddress, profile, rank} = useSelector(state => state.user);
    var rank_image = '';
    if(token) 
    {
        if(rank.total_score >= 3 && rank.total_score <= 4)
            rank_image = ic_bronze;
        else if(rank.total_score >= 5 && rank.total_score <= 8)
            rank_image = ic_silver;
        else if(rank.total_score >= 9 && rank.total_score <= 15)
            rank_image = ic_gold;
    }
        
    const {carts, storeSelected} = useSelector(state => state.shoppingCart);
    /*Deprecate*/
    const {activeMarket} = useSelector(state => state.markets);
    /*Deprecate*/
    const {cards} = useSelector(state => state.modalShoppingCard);
    const {list_stores, banners} = useSelector(state => state.stores);
    const dispatch = useDispatch();
    let history = useHistory();
    const {width} = useWindowDimensions();


    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery();
    const debt = query.get("debt");
    if(debt !== null && !isNaN(+debt))
    {
        if(token) {
            dispatch(actionChangeHandelModalAddPrice(true));
            dispatch(actionChangeInputsModalAddPrice("price", +debt));
        }
        else {
            dispatch(handelOpenModalLoginAndRegister());
        }
    }

    const handleSelectMarket = (data) => {
        if ((storeSelected && storeSelected.id !== data.id) && carts.length > 0) {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: 'modal-carrot-btn-successbase-btn-green btn btn-success ml-4',
                    cancelButton: 'base-btn-green-border btn btn-success',
                },
                buttonsStyling: false
            });
            swalWithBootstrapButtons.fire({
                text: 'سفارش از هر فروشگاه جداگانه ثبت می شود. با تغییر فروشگاه سبد خرید شما خالی می شود. آیا مایل به تغییر فروشگاه هستید؟',
                imageUrl: PUBLIC_URL_SERVER + 'icons/fm_logo_ofoghi_new.png',
                imageHeight: 45,
                imageAlt: 'فروت مروت',
                confirmButtonText: "بله",
                showCancelButton: true,
                cancelButtonText: 'انصراف',
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(actionRefreshModalShoppingCard());
                    history.push(`/stores/${data.id}`);
                }
            });
            // swal({
            //     title: "توجه",
            //     text: 'سفارش از هر فروشگاه جداگانه ثبت می شود. با تغییر فروشگاه سبد خرید شما خالی می شود. آیا مایل به تغییر فروشگاه هستید؟',
            //     buttons: {
            //         cancel: "انصراف",
            //         confirm: {
            //             text: 'بله',
            //             value: "ok",
            //         },
            //     },
            //     icon: "warning",
            // }).then((value) => {
            //     if (value === 'ok') {
            //         dispatch(actionRefreshModalShoppingCard());
            //         history.push(`/stores/${data.id}`);
            //     }
            // });
        } else {
            history.push(`/stores/${data.id}`);
        }
    };

    const openModalChangeShopping = () => {
        if (token) {
            /*API GET STORES*/
            apiHandelGetAddress();
            dispatch(actionModalChangeAddressChangeShow(true, 'home'));
        } else {
            dispatch(handelOpenModalLoginAndRegister());
        }
    };

    useEffect(() => {
        if (list_stores.length > 0) validationSelectedStore();
        // eslint-disable-next-line
    }, [list_stores]);

    const validationSelectedStore = () => {
        let findActiveMarket = false, findStoreSelected = false;

        if (storeSelected) findStoreSelected = list_stores.find(storeItem => storeItem.id === storeSelected.id);
        if (activeMarket) findActiveMarket = list_stores.find(storeItem => storeItem.id === activeMarket.id);

        if (findActiveMarket && cards.length > 0) {
            dispatch(actionChangeDataShoppingCart('carts', cards));
        }
        if (activeMarket !== '') {
            dispatch(changeSelectedDefaultMarket(''));
        }
        if (cards.length > 0) {
            dispatch(actionHandelRemoveAllItemInBasketCart());
        }
        if (!findStoreSelected && !findActiveMarket) {
            dispatch(actionChangeDataShoppingCart('carts', []));
        }
    }

    const apiHandelGetAddress = () => {
        dispatch(actionModalChangeAddressChangeLoader(true));
        axios({
            method: 'get',
            url: BASE_URL + USERS_ADDRESS_GET,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            dispatch(actionModalChangeAddressChangeLoader(false));
            dispatch(actionGetAddressUser(response.data.address));
        });
    };

    const openModalRankGuide = () => {
        // dispatch(handelOpenModalRankGuide());

        btnOkSingle.fire({
            html: `<div><div className="row mt-4"><div className="col-12 text-center"><img src=${ic_bronze}  alt={"برنز"} style="margin: 5px; width: 30px;" />برنز: 0 تا 5 سفارش</div></div><div className="row mt-3"><div className="col-12 text-center"><img src=${ic_silver}  alt={"نقره‌ای"} style="margin: 5px; width: 30px;" />نقره‌ای: 6 تا 15 سفارش</div></div><div className="row mt-3"><div className="col-12 text-center"><img src=${ic_gold}  alt={"طلایی"} style="margin: 5px; marginBottom: 10px; width: 30px;" />طلایی: 16 سفارش به بالا</div></div></div>`,
            imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
            imageHeight: 45,
            imageAlt: 'فروت مروت',
            confirmButtonText: "تایید",
        });
    };


    const handleModalLoginRegister = () => {
        dispatch(handelOpenModalLoginAndRegister());
    }

    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'base-btn-green-border btn btn-success',
        },
        buttonsStyling: false
    });
    const clickInfoCarrot = () => {
    	btnOkSingle.fire({
            text: "برای مشاهده جزئیات تبدیل امتیاز هویج به پول، به قسمت کیف پول خود   مراجعه کنید.",
            imageUrl: PUBLIC_URL_SERVER + '/images/icons/carrot_logo.png',
            imageHeight: 100,
            imageAlt: 'هویج',
            confirmButtonText: "باشه",
        });
    }

    return (
        <div className='page-stores'>
            <div className='stores-main'>
                <Container>
                    <div className='text-center pb-1 pb-lg-2'>
                        {token ?
                            <div>
                                <h5><b>{profile.fullname ? profile.fullname : 'پروفایل خود را تکمیل کنید'}</b>
                                {rank_image !== '' ?
                                <img src={rank_image} role="button"  onClick={openModalRankGuide} alt={rank.rank} width="30" className="ml-2" />
                                : '' }
                                </h5>
                                <p>
                                امتیاز شما: 
                                {profile.carrot_inventory}
                                <img src={ic_carrot}  alt={profile.carrot_inventory} width="23.25" className="ml-2" />
                                <FaInfoCircle className='icon-info-my-carrot-inventory ml-2' onClick={clickInfoCarrot} />
                                </p>
                                <p className='btn color-green' onClick={openModalChangeShopping}>
                                    <span>{activeAddress.address}</span>
                                    <FaAngleDown className='float-left ml-2'
                                                 style={{fontSize: 27}}/>
                                </p>
                                <p>
                                    <Button variant="success" className='base-btn-green'
                                            onClick={() =>window.open(ANDROID_APP_DOWNLOAD_URL)}>
                                        <span>دانلود اپلیکیشن اندروید</span>
                                    </Button>
                                </p>
                            </div>
                            :
                            <div>
                                <h5><b>خرید و ارسال سریع مواد غذایی</b></h5>
                                <div className="col-8  col-md-4 col-lg-3  mx-auto mb-1">
                                    <Button variant="success btn-block" className='base-btn-green'
                                            onClick={handleModalLoginRegister}>
                                        <span>ورود / ثبت نام</span>
                                    </Button>
                                    <br/>
                                    <Button variant="light btn-block" className='base-btn-white'
                                            onClick={() =>window.open(ANDROID_APP_DOWNLOAD_URL)}>
                                        <span>دانلود اپلیکیشن اندروید</span>
                                    </Button>
                                </div>
                                    
                            </div>
                        }
                    </div>
                </Container>
                <div>
                    {width > 576 &&
                    <div>
                        {banners.length === 1 ?
                            <LazyLoadImage
                                alt={banners[0].big_image}
                                src={PUBLIC_URL_SERVER + IMG_SLIDER_STORES_URL_SERVER + banners[0].big_image}
                                width={'100%'}
                                height={'200px'}
                            />
                            :
                            <Swiper slidesPerView={1} pagination={{clickable: true}} autoplay={{delay: 3500, disableOnInteraction: false}} loop={true}>
                                {_.map(banners, (banner, index) => (
                                    <SwiperSlide key={index}>
                                        <LazyLoadImage
                                            alt={banner.big_image}
                                            src={PUBLIC_URL_SERVER + IMG_SLIDER_STORES_URL_SERVER + banner.big_image}
                                            width={'100%'}
                                            height={'200px'}
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        }
                    </div>
                    }
                </div>
                <Container>
                    <div>
                        {width < 576 &&
                        <div>
                            {banners.length === 1 ?
                                <LazyLoadImage
                                    alt={banners[0].small_image}
                                    src={PUBLIC_URL_SERVER + IMG_SLIDER_STORES_URL_SERVER + banners[0].small_image}
                                    width={'100%'}
                                    height={'200px'}
                                />
                                :
                                <Swiper slidesPerView={1} pagination={{clickable: true}} autoplay={{delay: 3500, disableOnInteraction: false}} loop={true}>
                                    {_.map(banners,(banner, index) => (
                                        <SwiperSlide key={index}>
                                            <LazyLoadImage
                                                alt={banner.small_image}
                                                src={PUBLIC_URL_SERVER + IMG_SLIDER_STORES_URL_SERVER + banner.small_image}
                                                width={'100%'}
                                                height={'200px'}
                                            />
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            }
                        </div>
                        }
                    </div>
                    <div>
                        {storeSelected && Object.keys(storeSelected).length > 0 && carts.length > 0 ?
                            <div className="mt-3">
                                <h5><b>فروشگاه فعلی شما</b></h5>
                                <Row>
                                    <Col xs={12} md={6} lg={4}
                                         className='col-card-store-page-stores-fixed-shadow mb-3 mb-lg-0'>
                                        <div
                                            // className={`card-store-page-stores-fixed-shadow m-lg-2  ${loaderSelectedMarket === storeSelected.id ? '' : null}`}
                                            className={`card-store-page-stores-fixed-shadow m-lg-2`}
                                            onClick={() => handleSelectMarket(storeSelected)}>
                                            <div
                                                className={`box-arrow-page-stores-in-phone`}>
                                                <FaAngleRight className={'icon-angle-right-item-select-base-market'}/>
                                            </div>
                                            <div className='box-titles-card-store-page-stores'>
                                                <h6 className={'title-txt-item-select-base-market'}>{storeSelected.title}</h6>
                                                <p className={'body-txt-item-select-base-market color-gray m-0'}>{storeSelected.sub_title}</p>
                                                <p className={'time-send-item-select-base-market m-0'}>{storeSelected.first_delivery_time}</p>
                                            </div>
                                            <div className='text-center'>
                                                <LazyLoadImage
                                                    alt={storeSelected.title}
                                                    src={PUBLIC_URL_SERVER + ICONS_PUBLIC_URL_SERVER + storeSelected.icon}
                                                    width={60}
                                                    height={60}
                                                    placeholderSrc={imgPlayS}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            : null}
                        <div className='mt-3'>
                            <h5><b>فروشگاه ها</b></h5>
                            <Row>
                                {list_stores.length !== 0 ? list_stores.sort((a, b) => a.priority - b.priority).map(market => {
                                        return (
                                            <Col xs={12} md={6} lg={4} key={market.id} className='mb-3 mb-lg-0'>
                                                <div
                                                    // className={`card-store-page-stores m-lg-2  ${loaderSelectedMarket === market.id ? ' card-store-page-stores-click' : null}`}
                                                    className={`card-store-page-stores m-lg-2`}
                                                    onClick={() => handleSelectMarket(market)}>
                                                    <div
                                                        className={`box-arrow-page-stores-in-phone`}>

                                                        <FaAngleRight
                                                            className={'icon-angle-right-item-select-base-market'}/>
                                                    </div>
                                                    <div className='box-titles-card-store-page-stores'>
                                                        <h6 className={'title-txt-item-select-base-market'}>{market.title}</h6>
                                                        <p className={'body-txt-item-select-base-market color-gray m-0'}>{market.sub_title}</p>
                                                        <p className={'time-send-item-select-base-market m-0'}>{market.first_delivery_time}</p>
                                                    </div>
                                                    <div className='text-center'>
                                                        <LazyLoadImage
                                                            alt={market.title}
                                                            src={PUBLIC_URL_SERVER + ICONS_PUBLIC_URL_SERVER + market.icon}
                                                            width={60}
                                                            height={60}
                                                            placeholderSrc={imgPlayS}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                        )
                                    }) :
                                    <Col>
                                        <div className='loader-content-page text-center'>
                                            <img src={imgLoader} alt="logo Site"/>
                                            <span>لطفا منتظر بمانید...</span>
                                        </div>
                                    </Col>}
                            </Row>
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    );
}

export default ListStores;
